import { useLocation, useNavigate, useParams } from 'react-router-dom';

import React, { useEffect, useState } from 'react';

import { checkNafathLogin, checkoutActivation, checkoutConfirm, getOrderById, nafathLogin } from '../../../../services/sim.service';
import { trackPurchaseForOrder, trackPurchaseOrder } from '../../../../tools/tracking';

import { useTranslation } from 'react-i18next';
import { ShimmerTitle } from "react-shimmer-effects";
import { BiQrScan } from 'react-icons/bi';
import { BiChevronRight } from 'react-icons/bi';
import { TbDeviceSim } from 'react-icons/tb';
import { BiLoaderAlt } from 'react-icons/bi';
import { BiCheck } from 'react-icons/bi';
import Header from '../../../../components/header/header';
const LocalSimOrderCreate = () => {
    const hasProcessedRef = React.useRef(false);
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const [isLoading,setIsLoading] = useState<boolean>(true);
    const [order,setOrder] = useState<any>(null);
    const [provider,SetProvider] = useState<any>(null);
    const [verificationProccessError,setVerificationProccessError] = React.useState<string | null>(null);
    const {t,i18n} = useTranslation();


    // Add new state for plan type
    const [planType, setPlanType] = useState<'esim' | 'sim' | null>(null);

    // Add new state for ICCID input
    const [iccid, setIccid] = useState<string>('');
    const [isActivating, setIsActivating] = useState<boolean>(false);

  

    const verificationProcess = async() => {
        const id = searchParams.get('id');
        const providerOrderId = searchParams.get('providerOrderId');
        const amount = searchParams.get('amount');
        const providerCheckoutId = searchParams.get('providerCheckoutId');
        const tygoCheckoutId = searchParams.get('tygoCheckoutId');
        const tygoTransactionId = searchParams.get('tygoTransactionId');
        const paymentStatus = searchParams.get('paymentStatus') === 'true';
        const date = searchParams.get('date');
        const tygoOrderId = searchParams.get('tygoOrderId');
        const entityType = searchParams.get('entityType');
        const planId = searchParams.get('planId');
        const providerId = searchParams.get('providerId');
//https://tygo.sa/sim/order/create?providerOrderId=VRG-20260727-130017-Q8XIH&amount=61.75&providerCheckoutId=&tygoCheckoutId=541D79D4455F4E8F0716ABFC263D7862.prod02-vm-tx05&tygoTransactionId=tygo_wlfLhFOh1kSAnIXKITmHdw&paymentStatus=true&date=2026-07-27T10%3A00%3A40.433Z&tygoOrderId=45f6b29f-a435-4cb6-b35d-2e3b4964e787&entityType=VISA&providerId=12&planId=4268&id=541D79D4455F4E8F0716ABFC263D7862.prod02-vm-tx05&resourcePath=%2Fv1%2Fcheckouts%2F541D79D4455F4E8F0716ABFC263D7862.prod02-vm-tx05%2Fpayment
        const required = [
  providerOrderId,
  amount,
  tygoCheckoutId,
  tygoTransactionId,
  paymentStatus,
  date,
  tygoOrderId,
  entityType,
  providerId,
];

if (required.some(v => v === null)) {
  setVerificationProccessError("Invalid parameters");
  return;
}
        const data_to_be_sent = {
            providerOrderId,
            amount,
            providerCheckoutId,
            tygoCheckoutId,
            tygoTransactionId,
            paymentStatus,
            date,
            tygoOrderId,
            entityType,
        }
 

      


        try {
            const response = await checkoutConfirm(data_to_be_sent, +providerId!, planId || undefined);
            if(response)
            {
                // {
                //     "providerOrderId": "fb2ce3dc-6c80-42ad-9ac6-7e52f4758385",
                //     "tygoOrderId": "2a397836-f510-4f2e-9e81-83d780dcbd5b",
                //     "isConfirm": true
                //   }
                
                if(response.isConfirm)
                {
                    // Flat companion event for the Google tag: order_id, value,
                    // package. Must run before trackPurchaseForOrder, which
                    // clears the active checkout the package name is read from.
                    // Guarded against reloads on its own key.
                    trackPurchaseOrder({
                        orderId: tygoOrderId,
                        value: Number(amount) || 0,
                        packageId: planId,
                    });

                    // Only fired once the backend confirms the payment, never on
                    // the redirect alone. trackPurchaseForOrder is a no-op if
                    // this order was already tracked, so reloading this URL
                    // cannot double-count the conversion.
                    trackPurchaseForOrder(tygoOrderId, {
                        value: Number(amount) || 0,
                        payment_type: entityType || undefined,
                    });
                    //go to '/order/id
                    navigate(`/sim/order?id=${id}&providerId=${providerId}&tygoOrderId=${tygoOrderId}&providerOrderId=${providerOrderId}&planId=${planId}`);
                }
            }
        } catch (error: any) {
            setVerificationProccessError(error.message);
        }
    }
    React.useEffect(() => {
        if (!hasProcessedRef.current) {
            verificationProcess();
            hasProcessedRef.current = true;
        }
    }, []);
    //show if there is an error message and show the verificationProccessStates
    return (
        <>
            {verificationProccessError && <div>{verificationProccessError}</div>}
        </>
    );
}

export default LocalSimOrderCreate;
